import React, { useState, useEffect } from "react";
import { Link } from "@reach/router";
import { makeStyles } from "@material-ui/core/styles";
import { Button, IconButton, Typography } from "@material-ui/core";
import { MdClose } from "react-icons/md";
import { MdPauseCircleOutline, MdPlayCircleOutline } from "react-icons/md";
import ExerciseSuccess from "./ExerciseSuccess";
import BackgroundWrapper from "../base/BackgroundWrapper";
import { Wrapper } from "../base/Wrapper";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
  },
  contentContainer: {
    display: "flex",
    height: "90%",
    width: "100%",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  link: {
    color: theme.palette.grey[100],
    fontSize: "250%",
    float: "right",
  },
  timer: {
    color: "#fff",
    zIndex: 1,
    fontSize: "5rem",
  },
  text: {
    color: "#fff",
    zIndex: 1,
    fontSize: "2rem",
  },
  subText: {
    color: "#fff",
    zIndex: 1,
    fontSize: "1rem",
  },
  icon: {
    color: "#fff",
    zIndex: 1,
    height: "4.5em",
    width: "auto",
  },
  button: {
    marginBottom: theme.spacing(2),
  },
}));

function ExerciseScreen({ stNr, exName, navigate, location }) {
  const classes = useStyles();

  const [seconds, setSeconds] = useState(0);
  const [isActive, setIsActive] = useState(false);
  const [isFinished, setIsFinished] = useState(false);

  exName = exName.charAt(0).toUpperCase() + exName.slice(1);

  function toggle() {
    setIsActive(!isActive);
  }

  useEffect(() => {
    let interval = null;
    if (isActive) {
      interval = setInterval(() => {
        setSeconds((seconds) => seconds + 1);
      }, 1000);
    } else if (!isActive && seconds !== 0) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [isActive, seconds]);

  return (
    <>
      {!isFinished ? (
        <div>
          <BackgroundWrapper blurValue={2}>
            <Wrapper vh100>
              <div className={classes.root}>
                <div>
                  <Link alt="Schließen" to="../" className={classes.link}>
                    <MdClose />
                  </Link>
                </div>
                <div align="center">
                  <Typography alt="Stoppuhr starten" variant="body1" className={classes.timer}>
                    {new Date(seconds * 1000).toISOString().substr(14, 5)}
                  </Typography>
                  <Typography variant="h1" className={classes.text}>
                    {location.state.repetition ?? 1}x {exName}
                  </Typography>
                </div>
                <div align="center">
                  <IconButton onClick={toggle} className={classes.startButton}>
                    {isActive ? (
                      <MdPauseCircleOutline className={classes.icon} />
                    ) : (
                      <MdPlayCircleOutline className={classes.icon} />
                    )}
                  </IconButton>
                </div>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth={true}
                  className={classes.button}
                  style={seconds === 0 ? { visibility: "hidden" } : null}
                  onClick={() => {
                    setIsFinished(true);
                    setIsActive(false);
                  }}
                >
                  Training beenden
                </Button>
              </div>
            </Wrapper>
          </BackgroundWrapper>
        </div>
      ) : (
        <div>
          <ExerciseSuccess
            navigate={navigate}
            exName={exName}
            seconds={seconds}
            stNr={stNr}
            repetition={location.state.repetition ?? 1}
          />
        </div>
      )}
    </>
  );
}

export default ExerciseScreen;
